module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_privacy_m.668435486872b34cee958a31c425eccc.png";